var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolanaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 39,
    viewBox: "0 0 50 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_3774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12179 29.766C8.42353 29.4657 8.83841 29.2905 9.27844 29.2905H49.1829C49.9121 29.2905 50.2767 30.1664 49.7612 30.6794L41.8784 38.5244C41.5767 38.8247 41.1618 38.9999 40.7217 38.9999H0.817292C0.088099 38.9999 -0.276497 38.124 0.238966 37.611L8.12179 29.766Z",
    fill: "url(#paint0_linear_20_3774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12179 0.475457C8.4361 0.175168 8.85099 0 9.27844 0H49.1829C49.9121 0 50.2767 0.875842 49.7612 1.38884L41.8784 9.23388C41.5767 9.53417 41.1618 9.70934 40.7217 9.70934H0.817292C0.088099 9.70934 -0.276497 8.83349 0.238966 8.3205L8.12179 0.475457Z",
    fill: "url(#paint1_linear_20_3774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8784 15.0267C41.5767 14.7264 41.1618 14.5513 40.7217 14.5513H0.817292C0.088099 14.5513 -0.276497 15.4271 0.238966 15.9401L8.12179 23.7851C8.42353 24.0854 8.83841 24.2606 9.27844 24.2606H49.1829C49.9121 24.2606 50.2767 23.3848 49.7612 22.8718L41.8784 15.0267Z",
    fill: "url(#paint2_linear_20_3774)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_3774",
    x1: 45.3709,
    y1: -4.68656,
    x2: 17.9618,
    y2: 48.0657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_3774",
    x1: 33.2952,
    y1: -10.9607,
    x2: 5.88608,
    y2: 41.7916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_3774",
    x1: 39.2946,
    y1: -7.84376,
    x2: 11.8855,
    y2: 44.9085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_3774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaLogo);
export default __webpack_public_path__ + "static/media/solana-logo.cb70317224b0e6293f09263e7937c57d.svg";
export { ForwardRef as ReactComponent };